import { STRINGS } from '../constants/strings'
import LegalPage from './legalPage'

export default function PrivacyPage() {
  return <LegalPage content={STRINGS.privacy} />
}
